<template>
    <v-container grid-list-xs>
        <v-dialog v-model="dialog" width="500">

            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Поставщик
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-text-field v-model="newUser.fname" label="название" required></v-text-field>
                        <v-text-field v-model="newUser.info" label="информация" required></v-text-field>
                    
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="success" class="mr-4" @click="SaveUser">
                        Сохранить
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="mr-4" @click="dialog = false">
                        Отменить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12" md="6">
                <h1>Группа товаров</h1>
            </v-col>
            <v-col cols="12" md="6">
                <v-btn class="btn" @click="newData">Добавить</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Группа товаров
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Поиск" single-line
                            hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" @click:row="openData"></v-data-table>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>
  
<script>
// @ is an alias to /src


export default {
    name: 'Provider',
    data: () => ({
        newUser: {
            id: 0,
            fname: '',
            info:'',
        },
        dialog: false,
        search: '',
        headers: [
          {
            text: 'id',
            align: 'start',
            value: 'id',
          },
          { text: 'название', value: 'nameProvider' },
          { text: 'описание', value: 'info' },
        ],
        
    }),

    components: {

    },
    computed: {
        desserts() {
          return this.$store.getters.listProvider;
        },
    },
    methods: {
        newData(){
            this.newUser.id = 0;
            this.newUser.fname = '';
            this.newUser.info = '';
            this.dialog= true;
        },
        SaveUser() {
            this.$store.dispatch("newlistProvider", this.newUser);
            this.dialog = false;
        },
        openData(e){
            this.newUser.id = e.id;
            this.newUser.fname = e.nameProvider;
            this.newUser.info = e.info;
            this.dialog= true;
        }

    },
    mounted() {
        this.$store.dispatch("getlistProvider");
    }
}
</script>
  